
import Vue from 'vue'
import { authAxios } from '../utils'
import { Prop, Component } from 'vue-property-decorator'
import { VForm } from '../../global/vuetify.types'

@Component
export default class TermsConfirmation extends Vue {
  @Prop({ type: Boolean, default: false })
  private readonly value!: boolean

  get termsAndConditionsRules() {
    return [
      (v: boolean) => {
        return !!v || 'Please tick the box to continue'
      }
    ]
  }

  get form() {
    return this.$refs.form as VForm
  }

  async confirm() {
    if (this.form.validate()) {
      try {
        await authAxios.post('/terms-accepted',{}, {
          withCredentials: true
        })
      } catch (error) {
        // We don't really care if the request fails, they can just accept it later
      } finally {
        this.$store.commit('SET_ACCEPTED_TERMS', true)
        this.$emit('confirm')
      }
    }
  }
}
